import { observable, action } from "mobx";
import { ProfileService } from "modules/profile/ProfileService";
import { Company } from "./models/Company";
import { User } from "../login/models/User";
import { FirebaseDocument } from "common/models/FirebaseDocument";

import i18n from "i18n";

class Store {
  @observable ModalLinkCredencial: boolean = false;
  @observable companys: FirebaseDocument<Company>[];
  @observable password: boolean = false;
  @observable facebook = {
    linked: false,
    photoUrl: null,
  };
  @observable google = {
    linked: false,
    photoUrl: null,
  };
  @observable url: any = "";
  @observable file: any = null;
  @observable providerId: any = "";
  @observable message: string = "";
  @observable openSnackbar: boolean = false;
  @observable disabledBtn: boolean = true;
  @observable disableCPNBtn: boolean = true;
  @observable currentTab: Number = 0;
  @observable companyName: string = "";
  @observable companyLogoURL: any = "";
  @observable companyLogoFile: any = null;
  @observable companyInfos: boolean = false;
  @observable logoUpdate: boolean = false;
  @observable layerAdd: boolean = false;
  @observable users: FirebaseDocument<User>[] = [];
  @observable usersView: FirebaseDocument<User>[] = [];
  @observable isCurrentUserAdmin: boolean = false;
  search: string = "".toLowerCase();
  usersSearch: FirebaseDocument<User>[] = [];
  usersSnapshot: any = undefined;
  subscriptionLink: string = "https://www.rubk.com.br/assine-agora/";
  privacyPolicyLink: string =
    "https://www.senior.com.br/politica-de-privacidade";

  resetStore() {
    this.ModalLinkCredencial = false;
    this.password = false;
    this.facebook = {
      linked: false,
      photoUrl: null,
    };
    this.google = {
      linked: false,
      photoUrl: null,
    };
    this.url = "";
    this.file = null;
    this.providerId = "";
    this.message = "";
    this.openSnackbar = false;
    this.disabledBtn = true;
    this.currentTab = 0;
    this.companyInfos = false;
    this.logoUpdate = false;
    this.usersSearch = [];
    this.users = [];
    this.search = "";
    this.usersView = [];
    this.usersSnapshot;
    this.layerAdd = false;
    this.isCurrentUserAdmin = false;
  }

  @action
  setProviders(): void {
    let providerData = ProfileService.getProviderData();
    if (
      providerData.findIndex((prvdr) =>
        prvdr ? prvdr.providerId === "password" : false
      ) !== -1
    )
      this.password = true;
  }

  /**
   * Executa rotina para salvar dados da empresa.
   * @see {@link ProfileService#addCompanyImage}
   * @see {@link ProfileService#getCompanyImage}
   * @see {@link ProfileService#addCompany}
   * @see {@link ProfileService#updateCompanyWithLogo}
   * @see {@link ProfileService#updateCompany}
   * @method saveCompanyInfos
   * @category Users
   */
  @action
  async saveCompanyInfos() {
    let name = ProfileStore.companyName,
      url = ProfileStore.companyLogoURL,
      id = await ProfileService.getCompanyID();

    if (ProfileStore.companyInfos == false) {
      let change = false;
      if (ProfileStore.companyLogoFile) {
        await ProfileService.addCompanyImage(ProfileStore.companyLogoFile, id);
        url = await ProfileService.getCompanyImage({
          imageName: id + ProfileStore.companyLogoFile.name,
        });
        change = true;
      }
      ProfileService.addCompany(name, url);
      ProfileStore.companyInfos = true;
    } else {
      let id = await ProfileService.getCompanyID();

      if (ProfileStore.logoUpdate) {
        await ProfileService.addCompanyImage(ProfileStore.companyLogoFile, id);
        url = await ProfileService.getCompanyImage({
          imageName: id + ProfileStore.companyLogoFile.name,
        });
        await ProfileService.updateCompanyWithLogo(name, url, id);
        ProfileStore.logoUpdate = false;
      } else {
        await ProfileService.updateCompany(name, id);
      }
    }
    ProfileStore.message = i18n.company.saveCompany;
    ProfileStore.openSnackbar = true;
    ProfileStore.disableCPNBtn = true;
  }

  /**
   * Executa rotina para salvar remover logo da empresa.
   * @see {@link ProfileService#deleteCompanyLogo}
   * @method deleteLogo
   * @category Users
   */
  async deleteLogo() {
    let id = await ProfileService.getCompanyID();

    ProfileService.deleteCompanyLogo(id);
  }

  /**
   * Executa rotina para obter dados da empresa.
   * @see {@link ProfileService#fetchCompanyByUid}
   * @method getCompanyInfos
   * @category Users
   */
  @action
  async getCompanyInfos() {
    let company = await ProfileService.fetchCompanyByUid();

    if (company != null) {
      ProfileStore.companyName = company.name;
      ProfileStore.companyLogoURL = company.image;
    }
  }

  clearUsersSnapshot() {
    if (this.usersSnapshot) this.usersSnapshot();
  }
}

let ProfileStore = new Store();

export { ProfileStore };



// WEBPACK FOOTER //
// ./src/modules/profile/ProfileStore.ts